import {connect} from 'react-redux';
import {
    selectFullSchedule,
    selectGroupSchedule,
    selectTeacherSchedule,
    selectDepartmentSchedule,
    selectTeacherActiveSemestersScheduleStart,
} from '../../actions/schedule';
import GroupSchedulePage from '../../components/GroupSchedulePage/GroupSchedulePage';

const mapStateToProps = (state) => ({
    scheduleType: state.schedule.scheduleType,
    loading: state.loadingIndicator.mainScheduleLoading,
    groupSchedule: state.schedule.groupSchedule,
    fullSchedule: state.schedule.fullSchedule,
    teacherSchedule: state.schedule.teacherSchedule,
    groupData: state.schedule.scheduleGroup,
    teacherData: state.schedule.scheduleTeacher,
    departmentData: state.schedule.scheduleDepartment,
    semesterData: state.schedule.scheduleSemester,
    semesters: state.schedule.semesters,
    notPublished: state.schedule.notPublished,
    notPublishedMessage: state.schedule.notPublishedMessage,
    isManager: state.auth.role === 'ROLE_MANAGER' || state.auth.role === 'ROLE_ADMIN',
});

const mapDispatchToProps = (dispatch) => ({
    getGroupSchedule: (semester, group) => dispatch(selectGroupSchedule(semester, group)),
    getTeacherSchedule: (semester, teacher) => dispatch(selectTeacherSchedule(semester, teacher)),
    getFullSchedule: (semester) => dispatch(selectFullSchedule(semester)),
    getDepartmentSchedule: (semester, department) => dispatch(selectDepartmentSchedule(semester, department)),
    getTeacherActiveSemestersSchedule: (teacherId) => dispatch(selectTeacherActiveSemestersScheduleStart(teacherId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupSchedulePage);